import type { UploadOptions } from '../../types';
import type { ArDriveTag } from './types';

export function buildArDriveTags(options?: UploadOptions): ArDriveTag[] {
  const tags = [...(options?.tags ?? [])];

  if (options?.contentType) {
    tags.push({
      name: 'Content-Type',
      value: options.contentType,
    });
  }

  return tags;
}
